import { useMediaQuery } from './useMediaQuery'

/**
 * 是否在「可稳定悬停 + 精细指针」环境下展示 ChromeTooltip / 原生 title。
 * 触屏手机/平板主交互为 pointer: coarse 或 hover: none 时为 false，避免点按误触提示遮挡布局。
 */
export function usePreferHoverChromeTooltips(): boolean {
  return useMediaQuery('(hover: hover) and (pointer: fine)')
}
